import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-input.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiInput',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasFocus: {
      type: Boolean,
      default: false
    },
    isRedesign: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    };

    return (
      <div class={[styles.inputWrap, this.isRedesign ? styles.redesign : '']}>
        <div class={styles.inputTop}>
          {this.label.length > 0 ? (
            <label for={this.id} class={styles.inputLabel}>
              <span>
                {this.label}
                {this.required ? <span class={styles.requiredMark}>&nbsp;*</span> : null}
              </span>
              {this.maxLength ? (
                <span class={styles.inputCounter}>
                  <span>{this.value.length}</span> / {this.maxLength}
                </span>
              ) : null}
            </label>
          ) : null}
          {!this.maxLength ? (
            <div class={styles.additionalController}>{this.$slots.controller}</div>
          ) : null}
        </div>
        <input
          id={this.id}
          class={[
            styles.input,
            this.hasError ? styles.error : '',
            this.hasFocus ? styles.focus : ''
          ]}
          value={this.value}
          maxlength={this.maxLength}
          {...attributes}
        />
        {this.hasError ? <div class={styles.inputError}>{this.$slots.error}</div> : null}
      </div>
    );
  }
});
